require('../../modules/es6.array.for-each');
module.exports = require('../../modules/_core').Array.forEach;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/array/for-each.js
// module id = 146
// module chunks = 0